'use client';

import { useContext } from 'react';

import { AppContext } from '../App';
import Home from '../views/Home';

export default function Page() {
  const { kitchen } = useContext(AppContext);
  return <Home kitchen={kitchen} />;
}
